<p>risk-profile-details works!</p>
